"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _default = initialStateObject => {
  const [state, setState] = (0, _react.useState)(initialStateObject);
  const mutateState = partialState => setState({
    ...state,
    ...partialState
  });
  return [state, mutateState, setState];
};
exports.default = _default;